import { ExtendedTab, GlobalMyAccountFavoritesRoutes } from '@hdms/shared/common-types';

import { AccessService } from '../services';

export enum LocalMyAccountFavoritesRoutes {
  FAVORITE_LISTS = '/myaccount-favorites/my-favorites',
  FAVORITE_LIST_DETAILS = '/myaccount-favlists/details',
  COMPANY_LIST_DETAILS = '/myaccount-companylists/details'
}

export const MyAccountFavoritesRoutes = { ...GlobalMyAccountFavoritesRoutes, ...LocalMyAccountFavoritesRoutes };
export type MyAccountFavoritesRoutes = GlobalMyAccountFavoritesRoutes | LocalMyAccountFavoritesRoutes;

export enum MyAccountFavoritesTabId {
  MY_FAVORITES = 'my-favorites-tab',
  LAST_PURCHASES = 'last-purchases-tab',
  RECOMMENDATIONS = 'recommendations-tab',
  COMPANY_LIST = 'my-companylists-tab',
  SUBMITTALS = 'submittals-tab'
}

export interface MyAccountFavoritesTab extends ExtendedTab {
  id: string;
  path?: string;
  name?: string;
  enabled?: (a: AccessService) => boolean;
}
